// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  DispatchCustomerSummaryConnectionDetails,
  type DispatchCustomerSummaryConnectionDetailsWireFormat,
  NewDispatchCustomerSummaryConnectionDetails,
} from '../DispatchCustomerSummaryConnectionDetails/DispatchCustomerSummaryConnectionDetails';

export class DispatchCustomerSummary {
  readonly id: string;
  readonly name: string;
  readonly code: string;
  readonly creditStatusCode: string | null;
  readonly creditStatusDescription: string | null;
  readonly externalId: string;
  readonly companyId: string | null;
  readonly companyName: string | null;
  readonly integrationId: string | null;
  readonly companyConnectionDetails: DispatchCustomerSummaryConnectionDetails;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.code = data.code === undefined ? '' : data.code;
    this.creditStatusCode = data.creditStatusCode === undefined ? null : data.creditStatusCode;
    this.creditStatusDescription =
      data.creditStatusDescription === undefined ? null : data.creditStatusDescription;
    this.externalId = data.externalId === undefined ? '' : data.externalId;
    this.companyId = data.companyId === undefined ? null : data.companyId;
    this.companyName = data.companyName === undefined ? null : data.companyName;
    this.integrationId = data.integrationId === undefined ? null : data.integrationId;
    this.companyConnectionDetails = NewDispatchCustomerSummaryConnectionDetails(
      data.companyConnectionDetails,
    );
  }

  static zero(): DispatchCustomerSummary {
    const zeroValues: ExcludeMethodsDeep<DispatchCustomerSummary> = {
      id: NIL_UUID,
      name: '',
      code: '',
      creditStatusCode: null,
      creditStatusDescription: null,
      externalId: '',
      companyId: null,
      companyName: null,
      integrationId: null,
      companyConnectionDetails: DispatchCustomerSummaryConnectionDetails.zero(),
    };
    return new DispatchCustomerSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DispatchCustomerSummaryWireFormat = {
  id: string;
  name: string;
  code: string;
  creditStatusCode: string | null;
  creditStatusDescription: string | null;
  externalId: string;
  companyId: string | null;
  companyName: string | null;
  integrationId: string | null;
  companyConnectionDetails: DispatchCustomerSummaryConnectionDetailsWireFormat;
};

type NewDispatchCustomerSummaryProps = PartialDeep<
  DispatchCustomerSummary,
  { recurseIntoArrays: true }
>;
export const NewDispatchCustomerSummary: (
  props: NewDispatchCustomerSummaryProps,
) => DispatchCustomerSummary = (props) => new DispatchCustomerSummary(props);

type NewDispatchCustomerSummaryFromWireFormatProps = PartialDeep<
  DispatchCustomerSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewDispatchCustomerSummaryFromWireFormat: (
  props: NewDispatchCustomerSummaryFromWireFormatProps,
) => DispatchCustomerSummary = (props) => new DispatchCustomerSummary(props);
